<pk-broker-loader [show]="loading"></pk-broker-loader>
@if (!loading) {
	<form [formGroup]="formGroup">
		<div class="row">
			<div class="col-md-3">
				<div class="form-element-container">
					<pk-broker-form-dropdown formControlName="units" [options]="bidMeasureUnits" label="Units"></pk-broker-form-dropdown>
				</div>
			</div>
		</div>
		<h3>Bid Rate</h3>
		<div class="row">
			<div class="col-md-3">
				<div class="form-element-container">
					<label class="title" for="margin">Total Margin</label>
					<div class="input-group">
						<input type="number" class="form-control" [value]="margin" readonly />
						<div class="input-group-append">
							<span class="input-group-text">{{ form.units?.value?.text }}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-3">
				<div class="form-element-container">
					<label class="title required" for="bidAmount">Bid Rate</label>
					<div class="input-group">
						<input type="number" step="0.00001" class="form-control required" formControlName="bidAmount" />
						<div class="input-group-append">
							<span class="input-group-text">{{ form.units?.value?.text }}</span>
						</div>
					</div>
				</div>
				<p class="text-danger">*Ensure that the margin is included in the bid rate</p>
			</div>
		</div>
		<h3>Pricing Components</h3>
		<div class="row">
			<ng-container formArrayName="pricingComponents" *ngFor="let component of product.pricingComponents; let i = index">
				<div class="col-md-3 mb-3" [formGroupName]="i">
					<div class="card">
						<div class="card-body">
							<h3 class="card-title">{{ component.name }}</h3>
							<div class="input-group">
								<input class="form-control" type="number" step="0.00001" formControlName="amount" />
								<div class="input-group-append">
									<span class="input-group-text">{{ form.units.value?.text }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</ng-container>
			@if (!product.pricingComponents.length) {
				<div class="col-md-12">
					<div class="alert alert-warning">There are no pricing components for this product.</div>
				</div>
			}
		</div>
	</form>
}
